export function initVideos() {
  document.querySelectorAll("[data-video]").forEach((wrapper) => {
    const video = wrapper.querySelector("video")
    const button = wrapper.querySelector("[data-video-play]")
    if (!video || !button) return

    button.addEventListener("click", () => {
      wrapper.classList.add("is-playing")
      video.controls = true
      video.play()
      video.focus()
    })
  })
}
